import React, { useState, useEffect, useMemo } from "react";
import trashicon from "../../assets/images/icon/trashicon.png";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import styles from "./TentCartItemCard.module.css";
import { AutoComplete } from "primereact/autocomplete";
import { getTentHouseProviderServicesAPI } from "../../Apiservices/Auth/cart/Addtocart_api";
import { ShowDialogForPayment } from "../eventComponent/EventTabs/showdialogforpayment";
const TentCartItemCard = ({
  eventId,
  eventname,
  data = [],
  serviceType = "tentHouseData",
  refreshCart,
  removeItem,
  openEditDialog,
  selectedcartitem,
  ontentSelect,
  eventtitle,
  refundtentproviderfromcart,
  openRefundDialog,
}) => {
  const now = new Date();
  console.log("tentdata", data, eventId, eventname)
  const [showDialog, setShowDialog] = useState(false);
  const [editProvider, setEditProvider] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [filteredItems, setFilteredItems] = useState([]);
  const [addedItems, setAddedItems] = useState([]); // { mapping_id, service_name, checked, count }
  const [allServiceItems, setAllServiceItems] = useState([]);
  const [showDialogfor_refund, setShowDialogfor_refund] = React.useState(false);
  const originalQuantitiesRef = React.useRef({});

  const searchItems = (e) => {
    const query = e.query?.toLowerCase() || "";
    if (query.length >= 3) {
      const filtered = allServiceItems.filter((item) =>
        item.service_name.toLowerCase().includes(query)
      );
      setFilteredItems(filtered);
    }
  };

  const handleSelectItem = (item) => {
    const exists = addedItems.some((i) => i.mapping_id === item.mapping_id);
    if (!exists) {
      setAddedItems((prev) => [
        ...prev,
        { ...item, checked: true, count: 1 },
      ]);
    }
  };

  const handleCheckboxChange = (mapping_id, isChecked) => {
    setAddedItems((prev) =>
      prev.map((item) =>
        item.mapping_id === mapping_id
          ? { ...item, checked: isChecked, count: isChecked ? (item.count || 1) : 0 }
          : item
      )
    );
  };

  const handleCountChange = (mapping_id, value, checked) => {
    setAddedItems((prev) =>
      prev.map((item) =>
        item.mapping_id === mapping_id
          ? { ...item, count: value, checked }
          : item
      )
    );
  };
  const { is_edit_allowed, paid_amount, is_checked_out, balance_to_be_paid,
    is_cancel_in_progress,
    is_canceled
  } = data[0];
  console.log("check the price", data[0].Pricing)
  const { discountPrice, gstAmount, gstPercentage, price, totalAmount } = data[0].Pricing
  const showthefinalprice = totalAmount
  const getoriginaprice = price
  const hasdiscountfortent = getoriginaprice != discountPrice
  const showdiscountedprice = discountPrice

  const addedItemsSignature = useMemo(
    () =>
      JSON.stringify(
        addedItems.map(({ mapping_id, checked, count, cart_id }) => ({
          mapping_id,
          checked,
          count,
          cart_id,
        }))
      ),
    [addedItems]
  );
  const selectedAmount = selectedcartitem
    .find((p) => p.eventid === eventId)
    ?.services["tenthouse"]
    ?.find((pd) => pd.id === data[0].provider_id)?.total;


  const getUpdatedItems = () => {
    const originalQuantities = originalQuantitiesRef.current;
    // console.log("update",addedItems)
    return addedItems
      .filter(item => {
        const origQty = originalQuantities[item.mapping_id]?.quantity;
        if (typeof origQty === "undefined") return true;
        return item.count !== origQty;
      })
      .map(item => ({
        event_id: eventId,
        provider_id: data[0].provider_id,
        mapping_id: item.mapping_id,
        quantity: item.count,
        cart_id: item.cart_id,
      }));
  };
  // console.log("editProvider",editProvider)
  const handleSave = async () => {
    editProvider ?? setEditProvider(data?.[0]);
    const updatedItems = getUpdatedItems();
    // console.log("updated",updatedItems)
    if (updatedItems.length === 0) {
      console.log("No changes detected to save.");
      setShowDialog(false);
      refreshCart();
      window.scrollTo({ top: 0 });
      return;
    }

    try {
      if (!openEditDialog) {
        console.error("No openEditDialog function provided");
        return;
      }
      const result = await openEditDialog(eventId, editProvider.provider_id, updatedItems);
      if (result.success) {
        console.log("Cart updated successfully");
        setShowDialog(false);
        refreshCart();
        window.scrollTo({ top: 0 });
      } else {
        console.error("Failed to update cart:", result.message);
      }
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  };

  const getFinalPrice = (item) => {
    const validUpto = new Date(item.validUpto);
    if (!isNaN(validUpto) && now < validUpto && item.discountPrice > 0) {
      return item.discountPrice;
    }
    return item.price;
  };

  const handleRemove = async (providerId) => {
    try {
      await removeItem(eventId, providerId);
      refreshCart();
      window.scrollTo({ top: 0 });
    } catch (error) {
      console.error("Failed to remove tent item:", error);
    }
  };

  const handleEditClick = async (provider) => {
    setEditProvider(provider);
    setShowDialog(true);
  }
  const fetchAndSetTentHouseServices = async (provider) => {
    try {
      const response = await getTentHouseProviderServicesAPI(provider.provider_id);
      // console.log("tentdata", data);

      if (response?.data) {
        // Store original quantities and cart_ids
        const origDataMap = {};
        data?.[0]?.services?.forEach((svc) => {
          origDataMap[svc.mapping_id] = {
            quantity: svc.quantity,
            cart_id: svc.cart_id,
          };
        });
        originalQuantitiesRef.current = origDataMap;
        // console.log("mappeditems",response.data)
        // Map fetched services to addedItems format with correct cart_id
        const mappedItems = response.data.map((svc) => {
          const existing = origDataMap[svc.mapping_id] || { quantity: 0, cart_id: null };
          return {
            discount_price: svc.discount_price,
            price: svc.price,
            mapping_id: svc.mapping_id,
            service_id: svc.service.id,
            service_name: svc.service.service_name,
            checked: existing.quantity > 0,
            count: existing.quantity,
            cart_id: existing.cart_id,
          };
        });
        // console.log("mappeditems",mappedItems)
        setAddedItems(mappedItems);

        setAllServiceItems(
          response.data.map((svc) => ({
            mapping_id: svc.mapping_id,
            service_name: svc.service.service_name,
          }))
        );
      } else {
        setAddedItems([]);
        setAllServiceItems([]);
      }
    } catch (error) {
      console.error("Failed to fetch provider services:", error);
      setAddedItems([]);
      setAllServiceItems([]);
    }
  };

  useEffect(() => {
    if (data?.length) {
      data.forEach((provider) => {
        if (provider?.provider_id) {
          fetchAndSetTentHouseServices(provider); // pass provider object
        }
      });
    }
  }, [data]);
  const [showdeleteoverlay, setshowdeleteoverlay] = useState(false)
  const [showcancelationconfirmation, setshowcancelationconfirmation] = useState(false)
  const addGST = (amount) => {
    return Math.round(amount + (amount * 18) / 100);
  };
  // console.log("setShowDialogfor_refund",showDialogfor_refund)
  const deletepaidamount = async () => {

    try {
      const response = await refundtentproviderfromcart(parseInt(eventId, 10),
        parseInt(data[0].provider_id, 10))
      setshowcancelationconfirmation(true);
      refreshCart();
      openRefundDialog(["tentprovider"]);
      setShowDialogfor_refund(true)
    } catch (error) {

    }
    finally {
      setshowdeleteoverlay(false)
    }
  }
  const dialogFooter = (
    <div className={styles.dialogFooter}>
      <button
        className="p-button p-button-text"
        onClick={() => setShowDialog(false)}
      >
        Cancel
      </button>
      <button
        className="p-button p-button-primary"
        onClick={handleSave}
      >
        <i className="pi pi-check" style={{ marginRight: "0.5rem" }} />
        Save
      </button>
    </div>
  );
  const [showAll, setShowAll] = useState(false);

  const checkedItems = addedItems.filter(item => item.checked);
  const uncheckedItems = addedItems.filter(item => !item.checked);
  return (
    <div className={styles.cartItemWrapper}>
      <div className={styles.cartHeader}></div>

      {data.map((provider, idx) => {
        let totalOriginalAmount = 0;

        let totalDiscountAmount = 0;
        const now = new Date();
        let hasValidDiscount = false;
        provider.services.forEach((svc) => {
          const qty = svc.quantity ?? 1;
          const pricea = svc.price ?? 0;
          const servicesdiscountPrice = svc.discountPrice ?? null;
          const validUpto = new Date(svc.validUpto);


          const isDiscountValid =
            servicesdiscountPrice !== null &&
            servicesdiscountPrice > 0 &&
            validUpto instanceof Date &&
            !isNaN(validUpto) &&
            now < validUpto;

          // Always add original price
          totalOriginalAmount += pricea * qty;

          // Discount logic: only the difference if discount is valid, else full price
          if (isDiscountValid) {
            totalDiscountAmount += (servicesdiscountPrice) * qty;
            hasValidDiscount = true;
          } else {
            totalDiscountAmount += pricea * qty;
          }
        });
        const basetotal = provider.balance_to_be_paid && provider.balance_to_be_paid > 0 ? (provider.balance_to_be_paid) : (hasdiscountfortent ? showdiscountedprice : showthefinalprice);
        //  const basetotal =
        //     provider.balance_to_be_paid && provider.balance_to_be_paid > 0
        //       ? (provider.balance_to_be_paid)
        //       : (totalDiscountAmount ?? totalOriginalAmount);
        const tentGrandTotal =
          provider.balance_to_be_paid && provider.balance_to_be_paid > 0
            ? (provider.balance_to_be_paid)
            : (hasdiscountfortent ? showdiscountedprice : showthefinalprice);
        //  const tentGrandTotal =
        //     provider.balance_to_be_paid && provider.balance_to_be_paid > 0
        //       ? (provider.balance_to_be_paid)
        //       : (totalDiscountAmount ?? totalOriginalAmount);

        const hasDiscount = totalDiscountAmount > 0;


        return (
          <div className={styles.cartitemwraper}>
            <span style={{ fontSize: "24px", fontWeight: "600" }}>
              <span style={{
                display: "flex",
                justifyContent: "flexstart",
                marginTop: "0px",
              }}>Tenthouse

                <div style={{ marginLeft: "8px" }}>
                  {(hasDiscount && hasValidDiscount) ? (
                    <>
                      <span className={styles.discountedPrice}> ₹{totalOriginalAmount}</span>
                      <span className={styles.originalPrice}> ₹{totalDiscountAmount} </span>
                    </>
                  ) : (
                    <span className={styles.regularPrice} style={{ fontSize: "24px", fontWeight: "500" }}>₹{totalOriginalAmount}</span>
                  )}
                </div>
              </span>
            </span>
            <div key={idx} className={styles.cartItem}>

              <div className={styles.cartBodyInner}>
                {/* <div className={styles.cartPic} /> */}

                <div className={styles.cartData}>
                  <div className={styles.tenthousetopdata}>
                    <div className={styles.cartName}>
                      <span style={{ fontSize: "18px" }} >{provider.providername || "Tent Provider"}</span>

                    </div>

                  </div>
                  <div className={styles.tenthouseitems}>
                    {checkedItems.map((item) => (
                      <div key={item.mapping_id} className={styles.addeditemsincartpage}>

                        <label
                          htmlFor={`chk-${item.mapping_id}`}
                          className="item-label-serviceitem"
                        >
                          {item.service_name}
                        </label>

                        ({item.count})
                      </div>
                    ))}
                  </div>
                  {((paid_amount == 0) && !is_canceled) &&
                    <div className={styles.tenthouseeditcart}>
                      <div className={styles.tenthouseedit}>
                        <i style={{ color: "#26B8E3" }} className="pi pi-pencil"></i>
                        <button
                          className={styles.editBtn}
                          onClick={() => handleEditClick(provider)}
                        >
                          Edit items
                        </button>
                      </div>
                      <div className={styles.tenthousedelete}>
                        <img style={{ display: "flex", width: "16px", height: "18px", justifyContent: "center", marginRight: "6px" }} src={trashicon} alt='trashicon' />
                        <button
                          className={styles.removeBtn}
                          onClick={() => handleRemove(provider.provider_id)}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  }
                  {/* Right side: Status */}
                  {(is_cancel_in_progress || is_canceled) && (
                    <span style={{ color: "red", fontSize: "16px" }}>
                      Status{" Cancelled payment"}
                      {is_cancel_in_progress && <span> In progress</span>}{" "}
                      {is_canceled && <span>Canceled</span>}
                    </span>
                  )}
                  {/* cancel payment */}
                  {(paid_amount > 0) &&
                    <div className={styles.deletepayment} onClick={() => setshowdeleteoverlay(true)}>
                      <i className="pi pi-times" style={{ color: 'red' }}></i>
                      <button
                        className={styles.removeBtn}
                        onClick={() => {
                          setshowdeleteoverlay(true)
                          console.log("clicked delete", eventId, data[0].provider_id)
                        }

                        }
                      >
                        Cancel payment
                      </button>
                    </div>
                  }

                </div>
                <div className={styles.tentoptionsdata}>
                  <div className={styles.tentoptionsinfo}>
                    {/* <div className={styles.tentoptionsheader}>
                      <h3>Pay In Advance</h3>
                    </div>
                    <div className={styles.tentoptionslist}>
                      <label className={styles.priceoptions}>
                        <input
                          type="radio"
                          name={`payment-${eventId}-${data[0].provider_id}`}
                          checked={
                            !!selectedcartitem
                              .find((p) => p.eventid === eventId)
                              ?.services["tenthouse"]
                              ?.some(
                                (pd) => pd.id === data[0].provider_id && pd.total === tentGrandTotal
                              )
                          }
                          onClick={(e) => {
                            const isSelected =
                              selectedcartitem
                                .find((p) => p.eventid === eventId)
                                ?.services["tenthouse"]
                                ?.some(
                                  (pd) => pd.id === data[0].provider_id && pd.total === tentGrandTotal
                                ) || false;

                            if (isSelected) {
                              // 🔹 Unselect (toggle off)
                              ontentSelect(eventId, "tenthouse", false, {
                                id: data[0].provider_id,
                                cartid: [],
                                total: 0,
                              });
                              e.preventDefault(); // keep radio unchecked
                            }
                          }}
                          onChange={(e) => {
                            ontentSelect(eventId, "tenthouse", e.target.checked, {
                              id: data[0].provider_id,
                              cartid: data?.[0].services.map((svc) => ({
                                cart_id: svc.cart_id,
                                quantity: svc.quantity,
                                mapping_id: svc.mapping_id,
                              })),
                              total: tentGrandTotal,
                            });
                          }}
                        />
                        Total Amount
                      </label>

                      <label className={styles.priceoptions}>
                        <input
                          type="radio"
                          name={`payment-${eventId}-${data[0].provider_id}`}
                          checked={
                            !!selectedcartitem
                              .find((p) => p.eventid === eventId)
                              ?.services["tenthouse"]
                              ?.some(
                                (pd) => pd.id === data[0].provider_id && pd.total === tentGrandTotal * 0.5
                              )
                          }
                          onClick={(e) => {
                            const isSelected =
                              selectedcartitem
                                .find((p) => p.eventid === eventId)
                                ?.services["tenthouse"]
                                ?.some(
                                  (pd) => pd.id === data[0].provider_id && pd.total === tentGrandTotal * 0.5
                                ) || false;

                            if (isSelected) {
                              ontentSelect(eventId, "tenthouse", false, {
                                id: data[0].provider_id,
                                cartid: [],
                                total: 0,
                              });
                              e.preventDefault(); // keep radio unchecked
                            }
                          }}
                          onChange={(e) => {
                            ontentSelect(eventId, "tenthouse", e.target.checked, {
                              id: data[0].provider_id,
                              cartid: data?.[0].services.map((svc) => ({
                                cart_id: svc.cart_id,
                                quantity: svc.quantity,
                                mapping_id: svc.mapping_id,
                              })),
                              total: tentGrandTotal * 0.5,
                            });
                          }}
                        />
                        50%
                      </label>

                      <label className={styles.priceoptions}>
                        <input
                          type="radio"
                          name={`payment-${eventId}-${data[0].provider_id}`}
                          checked={
                            !!selectedcartitem
                              .find((p) => p.eventid === eventId)
                              ?.services["tenthouse"]
                              ?.some(
                                (pd) => pd.id === data[0].provider_id && pd.total === tentGrandTotal * 0.25
                              )
                          }
                          onClick={(e) => {
                            const isSelected =
                              selectedcartitem
                                .find((p) => p.eventid === eventId)
                                ?.services["tenthouse"]
                                ?.some(
                                  (pd) => pd.id === data[0].provider_id && pd.total === tentGrandTotal * 0.25
                                ) || false;

                            if (isSelected) {
                              ontentSelect(eventId, "tenthouse", false, {
                                id: data[0].provider_id,
                                cartid: [],
                                total: 0,
                              });
                              e.preventDefault(); // keep radio unchecked
                            }
                          }}
                          onChange={(e) => {
                            ontentSelect(eventId, "tenthouse", e.target.checked, {
                              id: data[0].provider_id,
                              cartid: data?.[0].services.map((svc) => ({
                                cart_id: svc.cart_id,
                                quantity: svc.quantity,
                                mapping_id: svc.mapping_id,
                              })),
                              total: tentGrandTotal * 0.25,
                            });
                          }}
                        />
                        25%
                      </label>
                    </div> */}


                  </div>

                  
                </div>
                <div className={styles.priceDetails}>
                    <div className={styles.priceDetails}>
                      <span className={styles.priceLabel}>Total: <span style={{ fontWeight: "600" }}>₹{provider.pricing?.price}</span> </span>
                      <span className={styles.priceLabel} style={{ color: "#666" }}>Taxes: <span style={{ fontWeight: "600", color: "#666" }}>₹{provider.pricing?.gstAmount}</span> </span>

                      <div style={{ borderTop: "1px solid #ddd", borderBottom: "1px solid #ddd", padding: "8px 0", margin: "8px 0" }}>
                        <span className={styles.priceLabel}>Sub Total: <span style={{ fontWeight: "600" }}>₹{provider.pricing?.totalAmount}</span> </span>
                      </div>
                    </div>

                    <div style={{ marginTop: "16px" }}>
                      <span className={styles.priceLabel}>Paid Amount: <span style={{ fontWeight: "600" }}>₹{paid_amount}</span> </span>
                    </div>

                    <span className={styles.regularPrice}>
                      <span>Balance to be paid:</span>
                      {!isNaN(provider.balance_to_be_paid) && provider.balance_to_be_paid > 0 ? (
                        <>
                          <span style={{ fontWeight: "600" }}>₹{provider.balance_to_be_paid}</span>
                        </>
                      ) : (
                        <>
                          <span style={{ fontWeight: "600" }}>₹{provider.pricing?.totalAmount}</span>
                        </>
                      )}
                    </span>

                    <div>
                      {selectedAmount && (
                        <div>
                          {/* <p style={{ fontWeight: "bold", marginTop: "10px" }}>
                            To Pay<s>₹{service.quantity * service.price}</s>
                            ₹{selectedAmount} <span style={{ fontSize: "14px", color: "#666" }}>(incl. GST) %</span>
                          </p> */}
                        </div>
                      )}
                    </div>
                  </div>
              </div>
            </div>
          </div>
        );
      })}




      {/* cancel dialog */}
      <Dialog
        visible={showdeleteoverlay}
        onHide={() => setshowdeleteoverlay(false)}
        header="Confirm Delete"
        footer={
          <div className="flex justify-end gap-2">
            <Button
              label="Cancel"
              icon="pi pi-times"
              onClick={() => setshowdeleteoverlay(false)}
              className="p-button-text"
            />
            <Button
              label="Delete"
              icon="pi pi-check"
              severity="danger"
              onClick={deletepaidamount}
              autoFocus
            />
          </div>
        }
      >
        <span>Are you sure you want to delete the paid tent Provider?</span>
      </Dialog>

      <Dialog
        visible={showcancelationconfirmation}
        onHide={() => setshowcancelationconfirmation(false)}
        header="Confirm Delete"
        footer={
          <div className="flex justify-end gap-2">
            <Button
              label="Okay"
              icon="pi pi-times"
              onClick={() => setshowcancelationconfirmation(false)}
              className="p-button-text"
            />

          </div>
        }
      >
        <span>You will get your amount back in some days</span>
      </Dialog>



      {/* Edit Dialog */}
      <Dialog
        header={`Select From ${editProvider?.providername || ""} in your area`}
        visible={showDialog}
        style={{ width: "60vw", maxHeight: "80vh" }}
        footer={dialogFooter}
        onHide={() => setShowDialog(false)}
        modal
      >
        {/* Search and Add Services */}
        <div className="input-container-serviceitem">
          <AutoComplete
            value={selectedItem}
            suggestions={filteredItems}
            completeMethod={searchItems}
            field="service_name"
            onChange={(e) => setSelectedItem({ service_name: e.value })}
            onSelect={(e) => handleSelectItem(e.value)}
            placeholder="Type at least 3 characters to search services"
            dropdown
            className="autocomplete-box-serviceitem"
          />
        </div>

        {/* Added Items */}
        <div className="added-items-container-serviceitem">

          <>
            {/* Always show checked items */}
            {checkedItems.map((item) => (
              <div key={item.mapping_id} className="added-item-serviceitem">
                <input
                  type="checkbox"
                  id={`chk-${item.mapping_id}`}
                  checked={item.checked}
                  onChange={(e) =>
                    handleCheckboxChange(item.mapping_id, e.target.checked)
                  }
                />
                <label
                  htmlFor={`chk-${item.mapping_id}`}
                  className="item-label-serviceitem"
                >
                  {item.service_name}
                </label>
                <input
                  type="number"
                  min="0"
                  max="1000"
                  value={item.count}
                  onChange={(e) => {
                    let newVal = parseInt(e.target.value);
                    if (isNaN(newVal) || newVal < 0) newVal = 0;
                    if (newVal > 1000) newVal = 1000;

                    if (newVal === 0) {
                      handleCountChange(item.mapping_id, 0, false);
                    } else {
                      handleCountChange(item.mapping_id, newVal, true);
                    }
                  }}
                  className="item-count-serviceitem"
                  disabled={!item.checked}
                />
              </div>
            ))}

            {/* Show unchecked items only if showAll = true */}
            {showAll &&
              uncheckedItems.map((item) => (
                <div key={item.mapping_id} className="added-item-serviceitem">
                  <input
                    type="checkbox"
                    id={`chk-${item.mapping_id}`}
                    checked={item.checked}
                    onChange={(e) =>
                      handleCheckboxChange(item.mapping_id, e.target.checked)
                    }
                  />
                  <label
                    htmlFor={`chk-${item.mapping_id}`}
                    className="item-label-serviceitem"
                  >
                    {item.service_name}
                  </label>
                  <input
                    type="number"
                    min="0"
                    max="1000"
                    value={item.count}
                    onChange={(e) => {
                      let newVal = parseInt(e.target.value);
                      if (isNaN(newVal) || newVal < 0) newVal = 0;
                      if (newVal > 1000) newVal = 1000;

                      if (newVal === 0) {
                        handleCountChange(item.mapping_id, 0, false);
                      } else {
                        handleCountChange(item.mapping_id, newVal, true);
                      }
                    }}
                    className="item-count-serviceitem"
                    disabled={!item.checked}
                  />
                </div>
              ))}

            {/* Show button only if unchecked items exist and not expanded */}
            {!showAll && uncheckedItems.length > 0 && (
              <button
                type="button"
                className={styles.selectmorebtn}
                onClick={() => setShowAll(true)}
              >
                + Select More
              </button>
            )}
          </>

        </div>
      </Dialog>
      <ShowDialogForPayment
        refundItems={["tentprovider"]}
        showDialog={showDialogfor_refund}
        setShowDialog={setShowDialogfor_refund}
      />
    </div>
  );
};

export default TentCartItemCard;
